module.exports = __webpack_public_path__ + "img/flagTRY.1f3da4af.svg";